import styled from "styled-components";
import Slider from "@material-ui/core/Slider";
import { makeStyles, withStyles } from "@material-ui/core";
import { colorTheme, textTheme } from "../../../theme";

export const Container = styled.div`
  margin-right: 15px;
  margin-left: 10px;
`;
export const Title = styled.div`
  display: flex;
  margin-bottom: 20px;
  margin-left: 5px;
  color: ${colorTheme.grayDark};
  ${textTheme.subtitle2}
`;

export const useStyles = makeStyles({
  root: {},
});

export const CustomSlider = withStyles({
  root: {
    width: "178px",
    color: "rgba(9, 142, 223, 0.35)",
    marginRight: "10px",
    marginLeft: "10px",
    marginBottom: "20px",
  },
  rail: {
    height: 8,
    borderRadius: 4,
    color: "#E2E5E6",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  thumb: {
    height: 24,
    width: 24,
    marginTop: -8,
    backgroundColor: "#FFFFFF",
    border: "1px solid #CED7DE",
    boxSizing: "border-box",
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.15)",
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 6px)",
    top: -20,
    "& *": {
      background: "transparent",
      color: "#000",
    },
    fontFamily: "Open Sans",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "400" as any,
    lineHeight: "20px",
    letterSpacing: "0.2px",
  },
})(Slider);
